module.exports = __webpack_public_path__ + "images/home-bg-header.jpg";